import React, { useState } from "react";

export default function ContactUs() {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);

    await fetch(
      "https://docs.google.com/forms/u/0/d/e/1FAIpQLSfKITbCx6LoS1oTg-PpfZjSb-wY3Tq0AOLdW2JN5p3Nh1IYaQ/formResponse",
      {
        method: "POST",
        body: formData,
        mode: "no-cors",
      }
    );

    setSubmitted(true);
    e.target.reset();
  };

  return (
    <div className="bg-white text-gray-800 px-6 md:px-16 lg:px-32 py-12">
      <h1 className="text-3xl md:text-4xl font-bold text-center mb-4">
        Contact Us
      </h1>
      <p className="text-justify text-gray-500 mb-12 max-w-xl mx-auto">
        Have a question, feedback, or collaboration idea? 
        We’d love to hear from you. Fill out the form below or reach out directly.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
        {/* Contact Form */}
        <form
          onSubmit={handleSubmit}
          className="space-y-6 bg-gray-50 p-6 rounded-xl shadow-lg"
        >
          <div>
            <label className="block text-sm font-medium mb-2">Full Name</label>
            <input
              type="text"
              name="entry.587988641"
              placeholder="Enter your name"
              required
              className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-black focus:outline-none"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-2">Email</label>
            <input
              type="email"
              name="entry.663394689"
              placeholder="you@example.com"
              required
              className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-black focus:outline-none"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-2">Message</label>
            <textarea
              rows="4"
              name="entry.816136381"
              placeholder="Tell us what’s on your mind..."
              required
              className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-black focus:outline-none"
            ></textarea>
          </div>

          <button
            type="submit"
            className="w-full bg-black text-white font-semibold py-3 rounded-lg hover:bg-gray-900 transition"
          >
            Send Message
          </button>

          {submitted && (
            <p className="text-green-600 text-center font-medium mt-4">
              ✅ Thank you! Your message has been sent. We’ll get back to you soon.
            </p>
          )}
        </form>

        {/* Contact Info */}
        <div className="flex flex-col justify-center space-y-6">
          <div>
            <h2 className="text-xl font-semibold mb-2">Email</h2>
            <p className="text-gray-600">support@dripptour.in</p>
          </div>

          <div>
            <h2 className="text-xl font-semibold mb-2">Phone</h2>
            <p className="text-gray-600">+91 9480743215</p>
          </div>

          <div>
            <h2 className="text-xl font-semibold mb-2">Address</h2>
            <p className="text-gray-600">
              DRIPP TOUR <br />
              Belagavi, Karnataka, India
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold mb-2">Follow Us</h2>
            <p className="text-gray-600"> • Instagram  </p>
          </div>
        </div>
      </div>
    </div>
  );
}
